<script setup lang="ts">
import ModalInMiddle from '@/components/Modal/ModalInMiddle.vue';
import router from '@/router';
import _service from '@/service';
import { useConfigStore } from '@/stores/config';
import { Field, Picker, Popup, Search, closeToast, showLoadingToast, showToast } from 'vant';
import { computed } from 'vue';
import { reactive } from 'vue';
import { toRaw } from 'vue';
import { ref } from 'vue';
import { onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';
const {t} = useI18n()
const showSaveModal = ref<boolean>(false)
const showCountryPicker = ref<boolean>(false)
const countryOriginList = ref<any[]>([])
const CountryPickerValue = ref<any[]>([])
const searchWord = ref<string>('')
const fieldValue = ref<string>('')
const configStore = useConfigStore()

const route = useRoute()

let form = ref<any>({
  id:"",
  email: "",
  firstName: "",
  lastName: "",
  address1: "",
  city: "",
  country: "",
  state: "",
  zipCode: "",
  phone: "",
  isDefault:true
})

const onPick = ({selectedValues,selectedOptions}:any) => {
  console.log(selectedValues,'selectedValues');
  console.log(selectedOptions,'selectedOptions');
  
  form.value.country = selectedValues[0]
  CountryPickerValue.value = selectedValues
  fieldValue.value = `${selectedOptions[0].chinese}(${selectedOptions[0].english})`
  showCountryPicker.value = false

}

const countryList = computed(()=>{
  console.log(countryOriginList.value,'countryOriginList.value');
  
  return countryOriginList.value.filter((item:any)=>{
    return searchWord.value ? item.label.toLowerCase().includes(searchWord.value) : item
  })
})

const getAddressById = async ()=> {
  console.log('getAddressById');
  
  const {data} = await _service.getAddressById({id:route.params.id})
  if (data) {
    form.value = data
    fieldValue.value = countryOriginList.value.filter((item:any)=>{
      return item.code === data.country
    })[0].label
    CountryPickerValue.value = [form.value.country]
  }
  
  closeToast()
}

const handleSaveAddress = async ()=> {
  console.log(form.value,'form');
  const excludeFields = ['id','address2','isDefault']
  for (const key in form.value) {
    if (!form.value[key] && !excludeFields.includes(key)) {
      showToast(t('Please fill in the form completely'))
      return false
    }
  }
  showSaveModal.value = true
}

const saveAddress = async ()=> {
  showLoadingToast({
    message: t("Loading"),
    duration: 0,
  });
  const postData = form.value
  try {
    if (route.params.id) {
      const {data} = await _service.updateAddress(postData)
      if (data) {
        showToast(t('Update success'))
        setTimeout(() => {
          router.back()
        }, 1000);
      }
    }else{
      const {data} = await _service.createAddress(postData)
      console.log(data,'data');
      if (data) {
        showToast(t('Create success'))
        setTimeout(() => {
          router.back()
        }, 1000);
      }
    }
  } catch (error) {
    console.log(error);
    showToast(`${error}`)
  }
}

onMounted(async ()=>{
  showLoadingToast({
    message: t("Loading"),
    duration: 0,
  });
  if (!configStore.getCounrtryList.length) {
    await configStore.getOriginCountry()
  }
  countryOriginList.value = configStore.getCounrtryList
  if (route.params?.id) {
    getAddressById()
  }else{
    closeToast()
  }
})
</script>

<template>
  <div class="new-address-layout">
    <div class="form flex-col-center-center">
      <div class="form-row flex-col-start-start">
        <div class="name flex-row-between-center">
          <span>{{t('First name')}}</span>
          <span>{{t('Last name')}}</span>
        </div>
        <div class="inputer flex-row-between-center">
          <input type="text" :placeholder="t('Please enter')" v-model="form.firstName">
          <input type="text" :placeholder="t('Please enter')" v-model="form.lastName">
        </div>
      </div>
      <div class="form-row flex-col-start-start">
        <div class="name">
          <span>{{t('Phone')}}</span>
        </div>
        <div class="inputer">
          <input type="text" :placeholder="t('Please enter')" v-model="form.phone" maxlength="20">
          <i class="clear" v-show="form.phone" @click="form.phone = ''"></i>
        </div>
      </div>
      <div class="form-row flex-col-start-start">
        <div class="name">
          <span>{{t('Country')}}</span>
        </div>
        <div class="inputer">
          <!-- <input type="text" :placeholder="t('Please enter')" v-model="form.country">
          <i class="clear" v-show="form.country" @click="form.country = ''"></i> -->
          <Field
            class="field"
            v-model="fieldValue"
            is-link
            readonly
            :label="t('Country')"
            :placeholder="t('Choose country')"
            @click="showCountryPicker = true"
          />
          <Popup v-model:show="showCountryPicker" round position="bottom">
            <Search
              v-model="searchWord"
              :placeholder="t('Please enter search keywords')"
              input-align="center"
            />
            <Picker
              :confirm-button-text="t('Confirm')" 
              :cancel-button-text="t('Cancel')"
              :columns="countryList"
              :columns-field-names="{
                 text: 'label', value: 'code',
              }"
              v-model="CountryPickerValue"
              @cancel="showCountryPicker = false"
              @confirm="onPick"
            />
          </Popup>
        </div>
      </div>
      <div class="form-row flex-col-start-start">
        <div class="name">
          <span>{{ t('State/Province') }}</span>
        </div>
        <div class="inputer">
          <input type="text" :placeholder="t('Please enter')" v-model="form.state">
          <i class="clear" v-show="form.state" @click="form.state = ''"></i>
        </div>
      </div>
      <div class="form-row flex-col-start-start">
        <div class="name">
          <span>{{t('City')}}</span>
        </div>
        <div class="inputer">
          <input type="text" :placeholder="t('Please enter')" v-model="form.city">
          <i class="clear" v-show="form.city" @click="form.city = ''"></i>
        </div>
      </div>
      <div class="form-row flex-col-start-start">
        <div class="name">
          <span>{{t('Address')}}</span>
        </div>
        <div class="inputer">
          <input type="text" :placeholder="t('Please enter')" v-model="form.address1">
          <i class="clear" v-show="form.address1" @click="form.address1 = ''"></i>
        </div>
      </div>
      <div class="form-row flex-col-start-start">
        <div class="name">
          <span>{{t('Zip code')}}</span>
        </div>
        <div class="inputer">
          <input type="text" :placeholder="t('Please enter')" v-model="form.zipCode">
          <i class="clear" v-show="form.zipCode" @click="form.zipCode = ''"></i>
        </div>
      </div>
      <div class="form-row flex-col-start-start">
        <div class="name">
          <span>{{t('Email')}}</span>
        </div>
        <div class="inputer">
          <input type="text" :placeholder="t('Please enter')" v-model="form.email">
          <i class="clear" v-show="form.email" @click="form.email = ''"></i>
        </div>
      </div>
    </div>
    <div class="for-bottom-area"></div>
    <div class="bottom-area media-375-fixed">
      <div class="bottom-btn" @click="handleSaveAddress">{{t('Save address')}}</div>
    </div>
    <ModalInMiddle v-model:isShow="showSaveModal" :title="t('Save address')">
      <div class="confirm-modal">
        <div class="ct">{{t('The address has been edited, do you want to save it?')}}</div>
        <div class="btn-group flex-row-between-center">
          <div class="btn gray flex-row-center-center"  @click="showSaveModal = false">{{t('Return')}}</div>
          <div class="btn flex-row-center-center" @click="saveAddress">{{t('Save')}}</div>
        </div>
      </div>
    </ModalInMiddle>
  </div>
</template>

<style lang="scss" scoped>
.new-address-layout{
  height: 100%;
  min-height: 100vh;
  background: #070B14;
  padding: 0 12px;
  padding-top: 18px;
  .form{
    gap: 16px;
    width: 100%;
    .form-row{
      width: 100%;
      .name{
        color: #9C9CAA;
        font-size: 12px;
        width: 100%;
        margin-bottom: 10px;
      }
      .inputer{
        width: 100%;
        border-radius: 8px;
        background: #1F212D;
        padding: 12px;
        display: flex;
        align-items: center;
        .van-cell{
          background: none;
          padding: 0;
          &::after{
            display: none;
          }
        }
        :deep(.van-field__label){
          color: #9C9CAA;
        }
        .field{
          :deep(.van-field__control){
            color: #fff;
          }
        }
        input{
          font-size: 16px;
          color: #fff;
          &::placeholder{
            color: #565662;
          }
          &:nth-child(2){
            text-align: right;
            border-left: 1px solid #545769;
          }
        }
        .clear{
          display: inline-block;
          width: 16px;
          height: 16px;
          background: url(../../assets/clear.svg);
          background-size: contain;
          background-repeat: no-repeat;
          background-position: center;
        }
      }
    }
  }
}
</style>
